import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {StructurePresenter} from './StructurePresenter';
import {BlockComponent} from './BlockComponent';
import {PresenterProps, withPresenter} from '../../support/with_presenter';
import {If} from '../../../../components/if';

interface OwnProps {
    canEditOutline: boolean;
    onSubmit: () => void;
}

const StructureComponent: FunctionComponent<OwnProps & PresenterProps<StructurePresenter>> = observer(
    ({presenter, canEditOutline, onSubmit}) => {
        return (
            <>
                <div className="row">
                    <div className="col-xs-12">
                        <If condition={presenter.blocks.length === 0}>
                            <div className="training-plan-editor__empty">
                                <div />
                                <div />
                                <div />
                            </div>
                        </If>
                        {presenter.blocks.map((block, i) => {
                            return (
                                <BlockComponent
                                    key={block.__uuid}
                                    number={i + 1}
                                    block={block}
                                    canEditOutline={canEditOutline}
                                    onChange={(updatedBlock) => presenter.onBlockChange(updatedBlock)}
                                    onPartAdd={(part) => presenter.onPartAdd(block, part)}
                                    onPartTrashClick={(part) => presenter.onPartTrashClick(part)}
                                    onTrashClick={() => presenter.onTrashBlockClick(block)}
                                />
                            );
                        })}
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <span className="training-plan-editor__summary">{presenter.totalTimeText}</span>
                        <button
                            className="btn btn-primary pull-right icon-left ion-md-checkmark"
                            onClick={() => onSubmit()}
                        >
                            Save
                        </button>
                        {canEditOutline && (
                            <div
                                className="btn btn-primary pull-right ion-ios-add-circle icon-left"
                                onClick={() => presenter.onAddBlockClick()}
                            >
                                Add block
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    },
);

export const Structure = withPresenter<StructurePresenter, OwnProps>(
    (props, component) => new StructurePresenter(component.blockInteractor),
    StructureComponent,
);
